module.exports = __webpack_public_path__ + "img/serviceplanner-banner-laptop-de.584ca5ce.webp";